import { Customer } from "./customer";
import { Product } from "./product";
import { Shop } from "./shop";

export interface Order {
    id: number
    createdAt: number
    updatedAt: number
    isDeleted: boolean
    code: string
    confirmedAt: number //Xác nhận đơn (Đã tiếp nhận) 
    deliveringAt: number //Đang v/c 
    completeAt: number //Thành công 
    canceledAt: number //Hủy 
    startLat: number // 
    startLong: number // 
    startAddress: string // 
    endLat: number // 
    endLong: number // 
    endAddress: string // 
    note: string // 
    //Danh cho shop booking 
    appointmentDate: string //ngày đặt lịch dành cho shop booking. Format: YYYY-MM-DD 
    appointmentHour: string //Giờ đặt lịch dành cho shop booking. Format: 
    amountOfPeople: string //Giờ đặt lịch dành cho shop booking. Format: 
    //end 
    paymentMethod: PaymentMethod
    receiverName: string
    receiverPhone: string
    status: OrderStatus
    subTotalMoney: number //tạm tính 
    moneyDistance: number //phí v/c 
    moneyFinal: number //Tiền khách cần trả
    customer: Customer;
    shop: Shop;
    details: OrderDetail[];
}





export enum PaymentMethod {
    COD = 'COD', //Thanh toán khi nhận hàng
    BankTransfer = 'BANK_TRANSFER', //Chuyển khoản ngân hàng
}

export const PaymentMethodTrans = {
    [PaymentMethod.COD]: 'Thanh toán khi nhận hàng',
    [PaymentMethod.BankTransfer]: 'Chuyển khoản ngân hàng',
}

export enum OrderStatus {
    Pending = 'PENDING',
    Confirm = 'CONFIRM',
    Delivering = "DELIVERING",
    Complete = 'COMPLETE',
    Cancel = 'CANCEL',
    Transferred = 'TRANSFERRED'
}

export const OrderStatusTrans = {
    [OrderStatus.Pending]: 'Mới',
    [OrderStatus.Confirm]: 'Đã xác nhận',
    [OrderStatus.Delivering]: 'Đang giao',
    [OrderStatus.Complete]: 'Hoàn tất',
    [OrderStatus.Cancel]: 'Hủy',
    [OrderStatus.Transferred]: 'Đã chuyển khoản'
}

export const OrderStatuses = [
    {
        label: OrderStatusTrans[OrderStatus.Pending],
        value: OrderStatus.Pending
    },
    {
        label: OrderStatusTrans[OrderStatus.Confirm],
        value: OrderStatus.Confirm
    },
    {
        label: OrderStatusTrans[OrderStatus.Delivering],
        value: OrderStatus.Delivering
    },
    {
        label: OrderStatusTrans[OrderStatus.Complete],
        value: OrderStatus.Complete
    },
    {
        label: OrderStatusTrans[OrderStatus.Cancel],
        value: OrderStatus.Cancel
    },
]


export interface OrderDetail {
    id: number
    createdAt: number
    updatedAt: number
    isDeleted: boolean
    price: number
    quantity: number
    product: Product;
    order: Order;
}
